export var AttachmentTypeEnum;
(function (AttachmentTypeEnum) {
    AttachmentTypeEnum["SimpleFile"] = "SimpleFile";
    AttachmentTypeEnum["Document"] = "Document";
})(AttachmentTypeEnum || (AttachmentTypeEnum = {}));
//# sourceMappingURL=attachmentType.js.map